import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=b5df7ea4&scoped=true&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewButton.vue?vue&type=style&index=0&id=b5df7ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df7ea4",
  null
  
)

component.options.__file = "ViewButton.vue"
export default component.exports